<template>
  <PageWithLayout>
    <div class="section section_main" :class="{_move_image: isTransformImage}">
      <div class="bg_main"></div>
      <div class="inner_section">
        <div class="main_info">
          <h2 class="screen_out">스마트팩토리 파트너사 설명</h2>
          <strong class="tit_section">T-fac은 파트너사와 함께<br/>편리함과 신속함을 더해주는<br/><strong>친숙한 스마트팩토리 서비스</strong>를 만들어갑니다.</strong>
        </div>
      </div>
    </div>
    <div class="section section_platform">
      <div class="inner_section">
        <h3 class="screen_out">스마트팩토리 플랫폼 설명</h3>
        <p class="desc_section" ref="platformDesc" :style="isPlatformDescObserved ? isObservedStyle : noObservedStyle">실질적인 제조 혁신에 앞장서기 위해 노력하는<br/>공급기업들과 함께합니다.</p>
        <p class="text_desc" ref="platformText" :style="isPlatformTextObserved ? isObservedStyle : noObservedStyle">카카오 기술에 혁신을 더한 T-fac은<br/>제조기술 및 제조환경의 혁신을 도모하는 공급기업과 협력하여<br/>더 편리한 스마트팩토리 플랫폼을 제공하고자 노력합니다.</p>
        <img ref="platformDiagram" :style="isPlatformDiagramObserved ? isObservedStyle : noObservedStyle" src="https://t1.kakaocdn.net/smartfactory/images/service/pc/platform_diagram.png" alt="" class="diagram">
      </div>
    </div>
    <div class="section section_connect">
      <Swiper class="bg_section" :options="swiperOptions">
        <swiper-slide>
          <span class="bg_area"><img src="https://t1.kakaocdn.net/smartfactory/images/service/pc/slide_bg01.jpg" alt="" class="bg_img"></span>
        </swiper-slide>
        <swiper-slide>
          <span class="bg_area"><img src="https://t1.kakaocdn.net/smartfactory/images/service/pc/slide_bg02.jpg" alt="" class="bg_img"></span>
        </swiper-slide>
      </Swiper>
      <div class="inner_section">
        <h3 class="screen_out">T-fac 비전</h3>
        <strong class="tit_section">새로운 세상, 새로운 연결</strong>
        <p class="desc_section">T-fac은 파트너사와 비전을 공유하고,<br/>
          카카오의 풍부한 경험과 다양한 기술 지원 제도를<br/>
          적극 운영하고 있습니다.<br/><br/>
          또한 파트너사와 기술을 협력하여<br/>
          공동 연구개발/마케팅/사업을 추진하고 있으며,<br/>
          스마트팩토리 시장에 미래 성장동력을 확보하고<br/>
          지속가능한 동반 성장을 추구하고 있습니다.</p>
      </div>
    </div>
    <div class="section section_connect2">
      <div class="inner_section">
        <h3 class="screen_out">T-fac 비전2</h3>
        <img ref="connectDiagram" :style="isConnectDiagramObserved ? isObservedStyle : noObservedStyle" src="https://t1.kakaocdn.net/smartfactory/images/service/pc/group.png" alt="" class="diagram">
        <div ref="connectBtn" :style="isConnectBtnObserved ? isObservedStyle : noObservedStyle" class="btnbox_g">
          <a href="javascript:void(0)" class="btn_inquiry" @click="moveToInquire">파트너사 문의</a>
        </div>
      </div>
    </div>
    <div class="section section_service">
      <div class="inner_section">
        <h3 class="screen_out">서비스 가입신청</h3>
        <strong class="tit_section">기업의 사용목적과 규모에 따라<br/>스마트팩토리 서비스를 선택해보세요</strong>
        <div class="btnbox_g">
          <!--        <button class="btn_service type1" @click="onClickService">서비스 신청하기</button>-->
          <a href="https://t1.kakaocdn.net/smartfactory/assets/images/service/pdf/tfac_intro.pdf" target="_blank" class="btn_service type_line"><span class="ico_brand ico_download"></span>서비스 소개서</a>
        </div>
      </div>
    </div>
  </PageWithLayout>
</template>
<script>
import {Swiper, SwiperSlide} from "vue-awesome-swiper";
import PageWithLayout from '@/components/layout/PageWithLayout';
import TiaraService from "@/plugins/TiaraService";

const tiaraService = TiaraService.getService();

export default {
  name: 'Partner',
  components: {
    PageWithLayout,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      swiperOptions: {
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        speed: 800,
        // cssMode: true,
        autoplay: {
          delay: 4500,
          disableOnInteraction: false, // 자동재생 중 움직였을때 바로 다시 자동재생을 막을지 유무
          waitForTransition: false // 자동재생 중 슬라이드내의 모션을 기다릴 것인지 유무
        }
      },
      isTransformImage: false,
      noObservedStyle: {
        opacity: 0,
        transform: `translateY(40px)`,
      },
      isObservedStyle: {
        opacity: 1,
        transform: 'translateY(0)',
        transition: `all 1.2s ease-out`,
      },
      isPlatformDescObserved: false,
      isPlatformTextObserved: false,
      isPlatformDiagramObserved: false,
      isConnectDiagramObserved: false,
      isConnectBtnObserved: false,
    }
  },
  updated() {
    this.bindEventScroll();
  },
  mounted() {
    tiaraService.trackPage('파트너사');
    this.isTransformImage = true;
    this.bindEventScroll();
    window.addEventListener('scroll', this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    bindEventScroll() {
      const winH = window.outerHeight * 0.8;
      const isPlatformDescObserved = 0 > this.$refs.platformDesc.getBoundingClientRect().top - winH;
      const isPlatformTextObserved = 0 > this.$refs.platformText.getBoundingClientRect().top - winH;
      const isPlatformDiagramObserved = 0 > this.$refs.platformDiagram.getBoundingClientRect().top - winH;
      const isConnectDiagramObserved = 0 > this.$refs.connectDiagram.getBoundingClientRect().top - winH;
      const isConnectBtnObserved = 0 > this.$refs.connectBtn.getBoundingClientRect().top - winH;
      this.isPlatformDescObserved = isPlatformDescObserved;
      this.isPlatformTextObserved = isPlatformTextObserved;
      this.isPlatformDiagramObserved = isPlatformDiagramObserved;
      this.isConnectDiagramObserved = isConnectDiagramObserved;
      this.isConnectBtnObserved = isConnectBtnObserved;
    },
    onScroll() {
      this.bindEventScroll();
    },
    moveToInquire() {
      this.$router.push( { name: 'Inquire', query: { type: 'partner' } } );
    }
  }
}
</script>
<style scoped>
/* common style */
.section {overflow: hidden;}
.inner_section{position:relative;width:1080px;margin:0 auto;box-sizing:border-box}
.inner_section.align_right{padding-left:670px;box-sizing:border-box}
.badge_section{display:inline-block;border:1px solid #999;border-radius:20px;padding:6px 24px 8px;font-weight:400;font-size:14px;line-height:24px;color:#222;vertical-align:top}
.module_top .txt_info{display:inline-block;position:relative;margin:9px 0 0 16px;padding-left:17px;font-size:14px;font-weight:300;color:#555;}
.module_top .txt_info:after{position:absolute;top:3px;left:0;width:1px;height:16px;background-color:#d8d8d8;content:''}
.module_top + .tit_section{margin-top:20px}
.tit_section{display:inline-block;font-weight:normal;font-family:'NotoSansKR_DL', sans-serif;font-size:44px;line-height:56px;color:#222;letter-spacing:-.05em}
.tit_section.type2{font-family:'NotoSansKR_M';font-weight:500;}
.desc_section{margin-top:32px;font-size:18px;line-height:28px;color:#666;letter-spacing:-.05em}
.list_section{margin-top:20px}
.list_section li{position:relative;padding-left:12px; font-family:'NotoSansKR_L', sans-serif;font-size:14px;line-height:26px;color:#555;letter-spacing:-0.5px}
.list_section li:after{position:absolute;top:13px;left:0;width:2px;height:2px;border-radius:50%;background-color:#222;content:''}
.img_g{position:absolute;display:block;overflow:hidden;font-size:0;line-height:0;text-indent:-9999px}
.text_desc{display:inline-block;font-family:'NotoSansKR_L', sans-serif;font-size:14px;line-height:26px;color:#555;letter-spacing:-0.5px}
.desc_section + .text_desc{margin-top:10px}
/* section main */
.section_main {overflow: hidden;position:relative;height: 860px;}
.section_main .bg_main {position:absolute;top:0;left:0;width:100%;height:100%;background: url(https://t1.kakaocdn.net/smartfactory/images/service/pc/main_visual2.jpg) no-repeat 50% 0;background-size: auto 100%;-webkit-transform: scale(1);-ms-transform: scale(1);transform: scale(1);-webkit-transition: -webkit-transform 5s ease-out;transition: -webkit-transform 5s ease-out;-o-transition: transform 5s ease-out;transition: transform 5s ease-out;transition: transform 5s ease-out,-webkit-transform 5s ease-out;}
.section_main .bg_main:before {position:absolute;top:0;left:0; width:100%;height:100%;background-color:rgba(0,0,0,.3);content:''}
.section_main._move_image .bg_main{-webkit-transform: scale(1.05);-ms-transform: scale(1.05);transform: scale(1.05);}
.section_main .inner_section {position: relative;z-index:1;height: 100%;padding-top:334px;text-align: center}
.section_main .tit_section {font-family:'NotoSansKR_M', sans-serif;font-size: 44px;line-height: 64px;color: #fff;}
.section_main .img_kakaotalk{position: absolute;top: 225px;left:300px;}
.section_main .desc_section{margin-top: 29px;font-size: 16px;line-height: 24px;color: #222;}
.section_main .img_phone{position: absolute;bottom: 0;right:-200px;width:716px;height:747px;}
.section_main .mouse_move{position:absolute;display: inline-block;bottom:44px;left:50%;margin-left:-40px;animation: mouseEffect 1s infinite forwards;}
/* section platform */
.section_platform {background-color: #1b2026;}
.section_platform .inner_section{padding:120px 0 80px;text-align:center}
.section_platform .desc_section{margin:0;font-size:32px;line-height:48px;color:#fff;}
.section_platform .desc_section + .text_desc{margin-top:24px;}
.section_platform .text_desc{font-size: 18px;line-height: 32px;color: #fff;}
.section_platform .diagram{display:block;width:832px;margin:60px auto 0;}
/* section connect */
.section_connect{position: relative;height:860px;}
.section_connect .bg_section{position:absolute;top:0;left:0;width:100%;height:100%;}
.section_connect .swiper-slide .bg_area{position:absolute;top:0;left:50%;height: 100%;transform: translateX(-50%);}
.section_connect .swiper-slide .bg_img{-webkit-transform: scale(1);-ms-transform: scale(1);transform: scale(1);-webkit-transition: -webkit-transform 5s ease-out;transition: -webkit-transform 5s ease-out;-o-transition: transform 5s ease-out;transition: transform 5s ease-out;transition: transform 5s ease-out,-webkit-transform 5s ease-out;}
.section_connect .swiper-slide.swiper-slide-active .bg_img{-webkit-transform: scale(1.05);-ms-transform: scale(1.05);transform: scale(1.05);}
.section_connect .inner_section{position: relative;z-index: 1;height:100%;padding:270px 0;}
.section_connect .tit_section{font-size:44px;line-height:56px;color:#fff;font-weight:bold}
.section_connect .desc_section{margin-top:40px;font-size: 18px;line-height: 28px;color: #fff;}
/* section connect2 */
.section_connect2{background-color:#f7f7f7;}
.section_connect2 .inner_section{padding:140px 0 116px;}
.section_connect2 .diagram{display: block;width: 1076px;margin: 0 auto;}
.section_connect2 .btnbox_g{margin-top:74px;text-align:center}
.section_connect2 .btn_inquiry{display:inline-block;padding:22px 80px;font-size: 24px;background-color:#ffe500;line-height: 36px;}
/* service */
.section_service{padding:100px 0 114px;background:url(https://t1.kakaocdn.net/smartfactory/images/service/pc/bg_service.jpg) no-repeat 50% 0;background-size:auto 440px;text-align:center}
.section_service .tit_section{font-size:32px;line-height:47px;color:#fff}
.section_service .btnbox_g{margin-top:52px}
.section_service .btn_service{display:inline-block;width:300px;height:80px;margin:0 6px;line-height:1;border-radius:3px;font-family:'NotoSansKR_M', sans-serif;font-size:24px;letter-spacing:-0.2px;background-color:#FFE500;color:#222}
.section_service .btn_service:hover{background-color:#E3CC00}
.section_service .btn_service.type_line{border:2px solid #fff;background-color:transparent;color:#fff;}
.section_service .btn_service .ico_download{margin:2px 12px 0 0}
.section_service a.btn_service{vertical-align:top;padding-top:26px;box-sizing:border-box;}
</style>
